import { Injectable } from "@angular/core";
import { AccountDataAdapter } from "./AccountDataAdapter";
import { AccountLookupService } from "../../lookup/model/impl/AccountLookupService";
import { ClientAccount } from "../../model/core/ClientAccount";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class ClientAccountAdapter {
  constructor(
    protected accountDataAdapter: AccountDataAdapter,
    protected accountLookupService: AccountLookupService,
  ) {}

  public transformClientAccount(client: CubiqTS.ClientImpl): ClientAccount {
    let result: ClientAccount = null;

    if (client) {
      result = new ClientAccount();

      result.clientCd = client.clientId;
      result.clientName = client.clientName;
      result.accounts = [];

      let accounts: CubiqTS.AccountImpl[] = null;
      accounts = this.accountLookupService.getAccountsForClient(client.clientId);

      if (accounts) {
        result.accounts = accounts.map(this.accountDataAdapter.transformAccount);
      }
    }

    return result;
  }
}
